export default __webpack_public_path__ + "static/media/bar2.89501d3a.png";